const permissions = {
  // Pesquisar
  AIRLINE_FLIGHT_LIST: "AIRLINE_FLIGHT_LIST",
  EXPORT_FLIGHTS: "EXPORT_FLIGHTS",
  ITINERARY_SEARCH: "ITINERARY_SEARCH",
  SEARCH_CREW: "SEARCH_CREW",
  SEARCH_PASSENGERS: "SEARCH_PASSENGERS",
  PASSENGER_DETAILS: "PASSENGER_DETAILS",

  // Relatórios
  API_REQUEST_REPORT: "API_REQUEST_REPORT",
  GRAPHIC_INDICATORS_API_REPORT: "GRAPHIC_INDICATORS_API_REPORT",
  GRAPHIC_INDICATORS_REPORT: "GRAPHIC_INDICATORS_REPORT",
  INDICATORS_EMBARQUESEGURO_REPORT: "INDICATORS_EMBARQUESEGURO_REPORT",
  INDICATORS_REPORT: "INDICATORS_REPORT",

  // Administração
  AIRLINE_MANAGE: "AIRLINE_MANAGE",
  AIRPORT_MANAGE: "AIRPORT_MANAGE",
  API_AUDIT_SEARCH: "API_AUDIT_SEARCH",
  BILLING_MANAGE: "BILLING_MANAGE",
  COUNTRY_MANAGE: "COUNTRY_MANAGE",
  ORGANIZATION_AIRPORT: "ORGANIZATION_AIRPORT",
  ORGANIZATION_MANAGE: "ORGANIZATION_MANAGE",
  ROLE_MANAGE: "ROLE_MANAGE",
  USER_AIRPORT: "USER_AIRPORT",
  USER_MANAGE: "USER_MANAGE",

  // Outros
  HELP_EDIT: "HELP_EDIT",
  HELP_READ: "HELP_READ",
  INTEGRATOR: "INTEGRATOR",
  UPDATES_EDIT: "UPDATES_EDIT",
  UPDATES_READ: "UPDATES_READ",
  PHOTOS_VIEW: "PHOTOS_VIEW"
};

export default permissions;
